<template>
  <router-view/>
</template>

<script>
export default {
  name: 'AlarmRule',
  routeInfo: {
    label: '报警规则'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/05AlarmRule/index.vue